import { NodeModel } from '@minoru/react-dnd-treeview';
import { getChildNodes } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    handlerOpenInconsistenciesModal: (
        startDate: string,
        endDate: string,
        employee: NodeModel[]
    ) => void;
};

export const controllerInconsistenciesModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    handlerOpenInconsistenciesModal,
}: Props) => {
    if (startDate && endDate && treeEmployees) {
        handlerOpenInconsistenciesModal(
            startDate,
            endDate,
            getChildNodes(treeEmployees)
        );
    }
};
